var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3496 6.25C24.3496 6.25 21.8496 5 18.7246 4.375L17.959 5.90563C17.0127 5.72563 16.0227 5.625 14.9996 5.625C13.9684 5.625 12.9702 5.72688 12.0171 5.90938L11.2496 4.375C8.12461 5 5.62461 6.25 5.62461 6.25C0.624609 11.875 1.24961 21.875 1.24961 21.875C3.12461 23.75 8.12461 25.625 8.12461 25.625C8.71523 25.0344 9.30586 24.0256 9.76461 23.125C8.17336 22.3969 7.49961 21.875 7.49961 21.875L7.96148 21.4131C9.92961 22.4869 12.3615 23.125 14.9996 23.125C17.6309 23.125 20.0559 22.49 22.0215 21.4219L22.4746 21.875C22.4746 21.875 21.8009 22.3969 20.2096 23.125C20.6684 24.025 21.259 25.0344 21.8496 25.625C21.8496 25.625 26.8496 23.75 28.7246 21.875C28.7246 21.875 29.3496 11.875 24.3496 6.25Z",
    fill: "#6C19FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62517 17.5C5.00017 13.125 8.12517 8.75005 8.12517 8.75005L12.5002 6.87505L12.0177 5.90942C10.2727 6.2438 8.68142 6.85942 7.34392 7.69192C6.64517 8.57567 3.76579 12.58 4.19954 17.9963C5.04267 19.3588 6.34704 20.5319 7.96204 21.4132L8.75017 20.625C6.76579 19.4919 5.62517 17.5 5.62517 17.5Z",
    fill: "#6C19FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7997 17.9961C26.2335 12.5799 23.3541 8.57552 22.6554 7.69177C21.3122 6.85552 19.7129 6.23864 17.9585 5.90552L17.4741 6.87489L21.8491 8.74989C21.8491 8.74989 24.9741 13.1249 24.3491 17.4999C24.3491 17.4999 23.2085 19.4918 21.2241 20.6249L22.021 21.4218C23.6435 20.5399 24.9541 19.3636 25.7997 17.9961Z",
    fill: "#6C19FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 18.75C12.0057 18.75 13.125 17.4908 13.125 15.9375C13.125 14.3842 12.0057 13.125 10.625 13.125C9.24429 13.125 8.125 14.3842 8.125 15.9375C8.125 17.4908 9.24429 18.75 10.625 18.75Z",
    fill: "#DDBAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3745 18.75C20.7552 18.75 21.8745 17.4908 21.8745 15.9375C21.8745 14.3842 20.7552 13.125 19.3745 13.125C17.9938 13.125 16.8745 14.3842 16.8745 15.9375C16.8745 17.4908 17.9938 18.75 19.3745 18.75Z",
    fill: "#DDBAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.6716606da6c4b624c60219a86971e9f9.svg";
export { ForwardRef as ReactComponent };